import { convertMarkdownStyleHyperlinksToHtml } from './links';
import { convertMarkdownStyleBoldToHtml } from './bold';
import { convertMarkdownStyleStrikethroughToHtml } from './strikethrough';
import { convertMarkdownStyleLineBreaksToHtml } from './lineBreaks';

export const markup_markdownLikeTextToHtmlString = (text?: string) => {
  if (!text) {
    return '';
  }

  let formattedText = text;
  formattedText = convertMarkdownStyleHyperlinksToHtml(formattedText);
  formattedText = convertMarkdownStyleBoldToHtml(formattedText);
  formattedText = convertMarkdownStyleStrikethroughToHtml(formattedText);
  formattedText = convertMarkdownStyleLineBreaksToHtml(formattedText);

  return formattedText;
};
